import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng-fe/container_content/common/client/commoncss/resetPC.css';
import Layout from './layout/';

/* eslint-disable no-undef */
ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
